import { FilteredGuest, MappedGuest } from '@features/DynamicPackagesConfigurationWizard/types';

import { getGuestGenderByTitle } from '@utils/helpers';
import { some } from '@utils/some';
import { toSnakeCase } from '@utils/toSnakeCase';
import { required } from '@utils/validators';
import { MappedLoggedGuestData } from './addToBasket';

export const appendExternalIdAndUserIdToFilteredGuests = (
  filteredGuests: FilteredGuest[],
  loggedInUserGuestData?: MappedLoggedGuestData | null
) => {
  return filteredGuests.map((guest) => {
    if (loggedInUserGuestData && compareGuests(loggedInUserGuestData, guest)) {
      return {
        ...guest,
        ...loggedInUserGuestData,
      };
    }
    return guest;
  });
};

export const isCompleteGuest = (guest: MappedGuest) =>
  !required(guest.firstName) && !required(guest.lastName) && !required(guest.title);

export function filterIncompleteGuests(
  guestDetails: MappedGuest[],
  loggedInUserGuestData: MappedLoggedGuestData | null
) {
  const filteredGuests = guestDetails
    .filter(isCompleteGuest)
    .map(({ title, firstName, lastName, gender, ...rest }) => ({
      title: title ?? '',
      firstName: firstName ?? '',
      lastName: lastName ?? '',
      gender: gender || getGuestGenderByTitle(title),
      ...rest,
    }));

  return appendExternalIdAndUserIdToFilteredGuests(filteredGuests, loggedInUserGuestData);
}
export const isGuestInFilteredList = (filteredGuests: MappedGuest[], guest: MappedGuest) =>
  some(filteredGuests, (filteredGuest) => compareGuests(filteredGuest, guest));

export function compareGuests(
  guest1: MappedLoggedGuestData | MappedGuest,
  guest2: { firstName?: string | null; lastName?: string | null; title?: string | null }
): boolean {
  return (
    guest1.firstName?.trim().toLowerCase() === guest2.firstName?.trim().toLowerCase() &&
    guest1.lastName?.trim().toLowerCase() === guest2.lastName?.trim().toLowerCase() &&
    guest1.title?.trim().toLowerCase() === guest2.title?.trim().toLowerCase()
  );
}

export const parseGuestDetails = (guest) => {
  const propertiesToCopy = [
    'title',
    'firstName',
    'lastName',
    'gender',
    'id',
    'email',
    'emailVerified',
    'agreedToMarketingEmail',
    'agreedToMarketingSms',
    'emailVerificationSentAt',
    'createdAt',
    'delivery',
    'payment',
    'sameAddressForBilling',
    'uuid',
    'externalSpaId',
    'spaMembership',
    'loggedInUser',
  ];

  const snakeCasedGuest = propertiesToCopy.reduce(
    (acc, key) => {
      if (guest[key] !== undefined) {
        const snakeCasedKey = toSnakeCase(key);
        acc[snakeCasedKey] = guest[key];
      }
      return acc;
    },
    {
      first_name: guest.firstName,
      last_name: guest.lastName,
      title: guest.title,
      gender: guest.gender,
    }
  );

  return snakeCasedGuest;
};
